module.exports = __webpack_public_path__ + "static/media/eleftheravoski.6d5b5e6c.jpg";